// import React from 'react';
// import Overview from './components/overview';
// import Demographics from './components/Demographics';
// import RecruitmentTransport from './components/RecruitmentTransport';
// import ControlOps from './components/ControlOps';
// import CaseManagement from './components/CaseManagement';

// function App() {
//   return (
//     <div style={{ padding: '20px' }}>
//       <h1>VOT Dashboard</h1>
//       <Overview />
//       <Demographics />
//       <RecruitmentTransport />
//       <ControlOps />
//       <CaseManagement />
//     </div>
//   );
// }

// export default App;

import React from 'react';
import Dashboard from './components/Dashboard';

const App = () => <Dashboard />;

export default App;